import React from 'react'
import { TrendingUp, TrendingDown, CheckCircle2 } from 'lucide-react'
import { formatCompactCurrency } from '../../applications/Traffic/utils'

export interface ChannelROICardProps {
  channel: {
    channel: string
    channelId: string
    roi: number
    roiLower: number
    roiUpper: number
    contributionPct: number
    totalSpend: number
    attributedRevenue: number
    recommendation: 'increase' | 'maintain' | 'decrease'
    color: string
  }
  currency: string
}

const recommendationConfig = {
  increase: { icon: TrendingUp, color: 'tw-text-green-600 tw-bg-green-50', label: 'Increase Spend' },
  maintain: { icon: CheckCircle2, color: 'tw-text-blue-600 tw-bg-blue-50', label: 'Maintain' },
  decrease: { icon: TrendingDown, color: 'tw-text-orange-600 tw-bg-orange-50', label: 'Reduce Spend' },
}

export function ChannelROICard({ channel, currency }: ChannelROICardProps) {
  const config = recommendationConfig[channel.recommendation]
  const RecIcon = config.icon

  return (
    <div className="tw-flex tw-items-center tw-justify-between tw-p-3 tw-bg-slate-50 tw-rounded-lg hover:tw-bg-slate-100 tw-transition-colors">
      <div className="tw-flex tw-items-center tw-gap-3">
        <div className="tw-w-3 tw-h-3 tw-rounded-full" style={{ backgroundColor: channel.color }} />
        <div>
          <p className="tw-font-medium tw-text-slate-900">{channel.channel}</p>
          <p className="tw-text-xs tw-text-slate-500">
            Spend: {formatCompactCurrency(channel.totalSpend, currency)}
          </p>
        </div>
      </div>
      <div className="tw-flex tw-items-center tw-gap-4">
        <div className="tw-text-right">
          <p className="tw-font-bold tw-text-lg tw-text-slate-900">{channel.roi.toFixed(1)}x</p>
          <p className="tw-text-xs tw-text-slate-500">
            [{channel.roiLower.toFixed(1)} - {channel.roiUpper.toFixed(1)}]
          </p>
        </div>
        <div className={`tw-flex tw-items-center tw-gap-1 tw-px-2 tw-py-1 tw-rounded-full tw-text-xs tw-font-medium ${config.color}`}>
          <RecIcon className="tw-w-3 tw-h-3" />
          <span>{config.label}</span>
        </div>
      </div>
    </div>
  )
}
